import React, { Component } from 'react';
import {Link, Redirect} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import { message, Tooltip, Spin,}  from 'antd';

import PsContext from '../../context/PsContext';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

class EditCustomer extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			isRedirect: false,
			editData: [],
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Edit Customer',
			back: true,
		});
		this.loadCustomer();
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadCustomer(){
		try{
			
			this.setState({showLoader: true});
			axios.get(Api.Url+'v1/customer?id='+this.props.match.params.id+'&api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						editData: res['data'].data[0],
						showLoader: false,
					});
				}
			});
		}		
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	getData(field){
		try{
			return this.state.editData[field];
		}
		catch(error){ }
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			this.setState({showLoader: true});
			 axios.post(Api.Url+'v1/customer/update', $("#frmEditCustoemr").serialize()).then(res=>{
				if(res['data'].status=='1'){
					
					message.success(res['data'].message || 'Success');
					this.setState({isRedirect: true});
				}	
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			 });
			
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	render(){

		if(this.state.isRedirect){
			return(<Redirect to="/app/customers" />);
		}
		
		return(
			<div className="container" >
			<div data-aos="fade" >
				
				<Spin spinning={this.state.showLoader} >
				
				<div className="card user-data-card">
					<div className="card-body">
						<form
							action=""
							method="post"
							encType="multipart/form-data"
							id="frmEditCustoemr"
							onSubmit={this.handleFormSubmit}
						>
						
						<input type="hidden" name="api" value={this.context.state.api} />
						<input type="hidden" name="i__id" value={this.getData('id')} />
						
						<Form.Group>
							<label>
								<span className="text-danger">* </span>
								Name
							</label>
							<Form.Control
								type="text"
								name="i__name"
								size="sm"
								defaultValue={this.getData('customer_name')}
								required
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger">* </span>
								Code
							</label>
							<Form.Control
								type="number"
								name="i__code"
								defaultValue={this.getData('customer_code')}
								size="sm"
								required
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Place
							</label>
							<Form.Control
								type="text"
								name="i__place"
								defaultValue={this.getData('customer_address')}
								size="sm"
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Mobile
							</label>
							<Form.Control
								type="number"
								name="i__mobile"
								defaultValue={this.getData('customer_mobile')}
								size="sm"
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Bank Account No
							</label>
							<Form.Control
								type="text"
								name="i__accountNo"
								defaultValue={this.getData('customer_bank_no')}
								size="sm"
							/>
						</Form.Group>
						
						<Row className="mt-30" >
							<Col md={12} >
								<Button
									type="submit"
									variant="success"
									size="md"
									block
									style={{width: '100%'}}
								>
									Save Customer
								</Button>
							</Col>
						</Row>
							
						</form>
					</div>
				  </div>
				
				</Spin>
				 
			</div>
			</div>
		);
	}
	
}
export default EditCustomer;
